import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";

@Component({
  selector: 'micro-system-applications',
  templateUrl: './system-applications.component.html'
})
export class SystemApplicationsComponent implements OnInit {

  url:string;

  constructor(private env:EnvService) {
  }

  ngOnInit() {
    this.url = `${this.env.e.url}/admin/#/`;
  }
}
